import { PackageType } from '@retail/products/types';
import { CampaignPricesDTO, PackageCalculationDTO } from '../../dto';
import { PriceDate } from './PriceDate';
import { PriceRoundingBrand } from '@retail/rounding/types';
import { CampaignPrices } from './CampaignPrices';

export interface PackageCalculationProps {
  packageType: PackageType;
  gtin: string;
  unit: string;
  consistsOfCount: number;
  consistsOfUnit: string;
  consistsOfPrimaryUnits: number;
  prices: PriceDate[];
  campaignPrices?: CampaignPricesDTO;
}

export class PackageCalculation {
  packageType: PackageType;
  gtin: string;
  unit: string;
  consistsOfCount: number;
  consistsOfUnit: string;
  consistsOfPrimaryUnits: number;
  prices: PriceDate[];
  campaignPrices?: CampaignPricesDTO;

  constructor({
    packageType,
    gtin,
    unit,
    consistsOfCount,
    consistsOfUnit,
    consistsOfPrimaryUnits,
    prices,
    campaignPrices,
  }: PackageCalculationProps) {
    this.packageType = packageType;
    this.gtin = gtin;
    this.unit = unit;
    this.consistsOfCount = consistsOfCount;
    this.consistsOfUnit = consistsOfUnit;
    this.consistsOfPrimaryUnits = consistsOfPrimaryUnits;
    this.prices = prices;
    this.campaignPrices = campaignPrices;
  }

  static fromDTO = (
    dto: PackageCalculationDTO,
    selectedBrand: PriceRoundingBrand
  ): PackageCalculation =>
    new PackageCalculation({
      packageType: dto.packageType,
      gtin: dto.gtin,
      unit: dto.unit,
      consistsOfCount: dto.consistsOfCount,
      consistsOfUnit: dto.consistsOfUnit,
      consistsOfPrimaryUnits: dto.consistsOfPrimaryUnits,
      prices: dto.prices.map((dto) => PriceDate.fromDTO(dto, selectedBrand)),
      campaignPrices: dto.campaignPrices ? CampaignPrices.fromDTO(dto.campaignPrices) : undefined,
    });
}
